<template>
<div class="wrapper">
    <modal :no-footer="true" size="large" @close="$emit('close')">
        <template slot="header">
            {{ facility.facility_number }} Contacts
        </template>

        <template slot="content">
            <div class="mb-3">
                Below is the contact information for facility {{ facility.facility_number }}.
            </div>

            <div class="flex jb-sb">
                <div class="flex-50 mr-3">
                    <h3>Manager</h3>

                    <strong>{{ facility.contact_name }}</strong>

                    <div>Email: <a :href="`mailto:${facility.email}`" target="_blank">{{ facility.email }}</a></div>
                    <div>Phone: {{ facility.phone }}</div>
                </div>

                <div class="flex-50 ml-3">
                    <h3>Additional Contacts</h3>

                    <div v-for="(contact, index) in facility.additional_contacts" :key="`view-contacts-${index}`" class="contact">
                        <strong>{{ contact.name }}</strong>
                        <div>{{ contact.title }}</div>

                        <div>Email: <a :href="`mailto:${contact.email}`" target="_blank">{{ contact.email }}</a></div>
                        <div>Phone: {{ contact.phone }}</div>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</div>
</template>

<script>
export default {
    name: "view-contacts-modal",

    props: {
        facility: {
            required: true,
            type: Object
        }
    }
}
</script>

<style scoped>
.contact + .contact {
    margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/list-facilities-page/ViewContactsModal.vue